import { render, staticRenderFns } from "./SetCityModal.vue?vue&type=template&id=8bbbf83a&scoped=true&"
import script from "./SetCityModal.vue?vue&type=script&lang=js&"
export * from "./SetCityModal.vue?vue&type=script&lang=js&"
import style0 from "./SetCityModal.vue?vue&type=style&index=0&id=8bbbf83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbbf83a",
  null
  
)

export default component.exports